import React, { MouseEventHandler, useCallback } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableItemRow } from 'app/area/codetable/list/list-items/common/codetable-item-row';

import { LinkCodesActionType, LinkCodesTranslation } from '../constants';
import { ListBranchItem } from '../types-store';
import { RowSelection } from '../types';

import { ListItemContent } from './list-item-content';

import styles from './list-item.scss';

interface ListItemProps {
  item: ListBranchItem;
  path: number[];
  checked: boolean;
  rowSelected: boolean;
  treeDepthLevel: number;
  hierarchyMode: boolean;
  hierarchyMetadata: HierarchyMetadata[];
  isZebra: boolean;
  open: boolean;
  expandItem: (id: number) => void;
  selectRow: (selection: RowSelection) => void;
  addAction: (path: number[], type: LinkCodesActionType, propagate: boolean) => void;
  translation: LinkCodesTranslation;
}

export const ListItem: React.FC<ListItemProps> = ({
  item, path, checked, rowSelected, treeDepthLevel, hierarchyMode, hierarchyMetadata, isZebra, open,
  expandItem, selectRow, addAction, translation
}) => {

  const onExpand = useCallback<MouseEventHandler>((event) => {
    event.stopPropagation();
    expandItem(item.id);
  }, [item, expandItem]);

  const onSelect = useCallback<MouseEventHandler>((event) => {
    selectRow({
      path,
      append: !!event.ctrlKey,
      range: !!event.shiftKey
    });
  }, [selectRow]);

  const expanderClass = [
    isZebra && styles.zebra,
    styles.expanderButton,
    open && styles.open,
    item.childrenCount === 0 && styles.hidden
  ].filter(style => style).join(' ');

  return <div className={rowSelected ? styles.rowSelected : styles.row}
    onClick={onSelect}>
    <CodetableItemRow
      isZebra={isZebra}
      treeDepthLevel={treeDepthLevel}>
      {hierarchyMode && <div className={styles.expanderButtonContainer}>
        <button type="button" className={expanderClass}
          onClick={onExpand}>
          <FiChevronDown />
        </button>
      </div>}
      <ListItemContent
        item={item}
        path={path}
        checked={checked}
        hierarchyMode={hierarchyMode}
        hierarchyMetadata={hierarchyMetadata}
        addAction={addAction}
        translation={translation} />
    </CodetableItemRow>
  </div>;
};
